import React, { useContext } from 'react';
import ConfigContext from 'choerodon-ui/lib/config-provider/ConfigContext';
import { observer } from 'mobx-react-lite';
import { $l } from '../locale-context';
import Button from '../button/Button';
import { ButtonColor } from '../button/enum';
const CountDownButton = function CountDownButton(props) {
    const { getProPrefixCls } = useContext(ConfigContext);
    const prefixCls = getProPrefixCls('secret-field');
    const { onClick, countDown, verifyNumber } = props;
    const { count } = countDown;
    return (React.createElement(Button, { className: `${prefixCls}-modal-verify-btn`, color: ButtonColor.primary, disabled: count > 0 || !verifyNumber, onClick: onClick }, count > 0 ? `${count}s` : $l('SecretField', 'get_verify_code')));
};
CountDownButton.displayName = 'CountDownButton';
export default observer(CountDownButton);
